// extracted by mini-css-extract-plugin
export var pillWrapper = "_oq-0";
export var showOverflow = "_oq-1";